import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractTransactionTypeCreateForm from "./create";
import ContractTransactionTypeEditForm from "./edit";
import {
  getContractTransactionTypeDetails,
  getContractTransactionTypes,
} from "src/store/contract-transaction-type/saga";
import {
  ContractTransactionTypeDetailDto,
  ContractTransactionTypeDto,
} from "src/store/contract-transaction-type/type";
const ContractTransactionTypesPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ContractTransactionTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ContractTransactionTypeDetailDto>();
  const columns = [
    {
      text: t("Contract.TransactionType.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.TransactionType.PageTitle")}
        metaTag={t("Contract.TransactionType.MetaTag")}
        gridProps={{
          addTitle: t("Contract.TransactionType.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getContractTransactionTypes,
          // onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getContractTransactionTypeDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          // deleteButton: {
          //   text: (id, data: SectorDto) =>
          //     t("Contract.TransactionType.DeleteQA", {
          //       name: data.Name,
          //     }),
          //   action: deleteSectorSaga,
          //   onClick: (id, data) => setShowEdit(data),
          // },
        }}
      />
      <ContractTransactionTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getContractTransactionTypes,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractTransactionTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getContractTransactionTypes,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractTransactionTypesPage;
